import React from 'react';
import { IChartCardLeftProps } from '.';

const NumberLeft: React.FC<IChartCardLeftProps> = ({ helper }) => (
  <p className="f1 display mv0 blue">
    {helper.aggregate({
      aggregationType: 'sum',
      seriesType: 'sum'
    }) || 0}
  </p>
);

export default NumberLeft;
